// extracted by mini-css-extract-plugin
export default {"privacyZonesLegend":"PrivacyZonesLegend--privacyZonesLegend---zhYe","section":"PrivacyZonesLegend--section--hTmXT","label":"PrivacyZonesLegend--label--iWla5"};